export const createMapFocusOrderMaintainer = (): MutationObserver => {
    class MapElementObserver extends MutationObserver {
        public target?: Node;
        observe(target: Node) {
            this.target = target;
            super.observe(target, {childList: true, subtree: true});
        }
        disconnect() {
            this.target = undefined;
            super.disconnect();
        }
    };
    return new MapElementObserver((mutationList: MutationRecord[], observer: MapElementObserver) => {
        const mapContainer = observer.target as HTMLElement;
        const controlContainer = mapContainer.querySelector('.maplibregl-control-container');
        const canvasContainer = mapContainer.querySelector('.maplibregl-canvas-container');

        if (controlContainer && canvasContainer && controlContainer.nextElementSibling === canvasContainer) {
            canvasContainer.insertAdjacentElement('afterend', controlContainer);
        }

        if (canvasContainer && !canvasContainer.querySelector('.maplibregl-canvas:last-child')) {
            canvasContainer.insertAdjacentElement('beforeend', canvasContainer.querySelector('.maplibregl-canvas'));
        }

        mapContainer.querySelectorAll('.maplibregl-popup').forEach((popup:HTMLElement) => {
            const popupContent = popup.querySelector('.maplibregl-popup-content');
            if (popupContent && popupContent.querySelector('.maplibregl-popup-close-button:last-child')) {
                popupContent.insertAdjacentElement('afterbegin', popupContent.querySelector('.maplibregl-popup-close-button'));
            }
        });

    });
};
